<div class="card-row" [ngClass]="{'card-row-expanded': order.expanded}">
  <div class="flex flex-row p-3">
    <div style="width: 48%" class="flex flex-row justify-content-between align-items-center border-right-1 border-300 pr-border">

      <div class="flex flex-row w-5 align-items-center">
        <div class="flex">
          <img *ngIf="order.varietyUrlIcon" [src]="getIconUrl(order.varietyUrlIcon) | speciesImageUrl"
            style="border-radius: 7px; width: 100%; min-width: 30px; max-width: 50px; height: auto;"
            alt=""
          />
          <span *ngIf="!order.varietyUrlIcon"
            class="material-symbols-outlined" style="font-size: 40px; opacity: .3; color:#8C2B87">
            no_photography
          </span>
        </div>
        <div class="flex flex flex-column pl-2">
          <span class="text-base font-semibold my-0">
            {{ order | speciesName }} {{ order.varietyName }}
          </span>
          <!-- Instructivo -->
          <div *ngIf="isProgram" class="flex flex-row wrap-text text-size-base">
            <span class="text-main-color font-medium pr-1">
              {{ 'UserPages.UserLoadOrdersProgram.MainTable.InstructiveBtn' | translate }}:
            </span>
            <span class="text-sub-color" [ngClass]="{'font-italic': !order.instructions}">
              {{ order.instructions ?? 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}
            </span>
          </div>
          <!-- Contenedor -->
          <div class="flex flex-row wrap-text text-size-base">
            <span class="text-main-color font-medium pr-1">
              {{ 'UserPages.UserLoadOrdersProgram.MainTable.ContainerHeader' | translate }}:
            </span>
            <span class="text-sub-color" [ngClass]="{'font-italic': !order.containerNumber}">
              {{ order.containerNumber ?? 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}
            </span>
          </div>
          <!-- Orden -->
          <div class="flex flex-row wrap-text text-size-base">
            <span class="text-main-color font-medium pr-1">
              {{ 'UserPages.UserLoadOrdersProgram.MainTable.OrderHeader' | translate }}:
            </span>
            <span class="text-sub-color" [ngClass]="{'font-italic': !order.sequence?.toString()}">
              {{ order.sequence?.toString() ?? 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex w-3 justify-content-start">
        <div class="flex flex-column pl-2">

          <!-- Programa -->
          <div *ngIf="isProgram" class="flex flex-row flex-wrap text-size-base">
            <span class="text-main-color font-medium pr-1">
              {{'UserPages.UserLoadOrdersProgram.SubTable.ProgramHeader' | translate}}:
            </span>
            <span class="text-sub-color" [ngClass]="{'font-italic': !order.programId}">
              {{ order.programId ?? 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}
            </span>
          </div>
          <!-- Pallets -->
          <div class="flex flex-row text-size-base">
            <span class="text-main-color font-medium pr-1">
              {{ 'UserPages.UserLoadOrdersProgram.MainTable.PalletsHeader' | translate }}:
            </span>
            <span class="text-sub-color" [ngClass]="{'font-italic': !order.totalPallets?.toString()}">
              {{ order.totalPallets?.toString() ?? 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-row w-4 justify-content-start">
        <div class="flex flex-column pt-1">
          <div class="flex align-items-center">

            <div *ngIf="order.orderDocumentStatus == 0"
              class="flex flex-row align-items-center text-size-base">
              <i class="pi pi-exclamation-triangle status-icon bg-red"></i>
              <p class="pl-2 text-sub-color">
                {{'UserPages.UserLoadOrders.SubTable.Status.PalletPending' | translate}}
              </p>
            </div>

            <div *ngIf="order.status >= 4 && order.orderDocumentStatus === 1"
              class="flex flex-row align-items-center text-size-base">
              <i class="pi pi-exclamation-triangle status-icon bg-yellow"></i>
              <span class="pl-2 text-sub-color">
                {{'UserPages.UserLoadOrders.SubTable.Status.DocumentPending' | translate}}
              </span>
            </div>

            <div *ngIf="order.status >= 4 && order.orderDocumentStatus === 2"
              class="flex flex-row align-items-center text-size-base">
              <i class="pi pi-check status-icon bg-green"></i>
              <span class="pl-2 text-sub-color">
                {{'UserPages.UserLoadOrders.SubTable.Status.OrderConfirmed' | translate}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 52%" class="flex flex-row justify-content-between align-items-center pl-border">
      <!-- Puerto origen -->
      <div class="flex justify-content-start" style="width: 25%;">
        <div class="flex justify-content-start align-items-center">
          <app-location-info
          [type]="order.transportType"
          [countryCode]="order.originPort?.country?.code || order.originAirport?.country?.code || order.originCity?.country?.code"
          [countryName]="order.originPort?.country ?
            (order.originPort?.country | countryDescription) :
            (order.originAirport?.country ?
            (order.originAirport?.country | countryDescription) :
            (order.originCity?.country ?
            (order.originCity?.country | countryDescription) : ''))"
          [portName]="order.originPort?.name"
          [airportName]="order.originAirport?.name"
          [cityName]="order.originCity?.name"
          [showLocationName]="true"
          [useFigureIcon]="true"
          >
          </app-location-info>
        </div>
      </div>

      <div class="flex justify-content-center" style="width: 17%;">
        <!-- <div class="flex flex-column justify-content-center flex-wrap">
          <div class="flex justify-content-center flex-wrap">
            <span *ngIf="order.transportType === 0"
              class="material-symbols-outlined text-secondary-color icon-size icon-port">directions_boat</span>
            <span *ngIf="order.transportType === 1"
              class="material-symbols-outlined text-secondary-color icon-size icon-port">flight</span>
            <span class="material-symbols-outlined text-secondary-color icon-size">arrow_forward_ios</span>
          </div>
          <div *ngIf="order.ship" class="flex justify-content-center flex-wrap">
            <span class="text-size-base">{{ order.ship }}</span>
          </div>
        </div> -->
        <app-transport-type-icon
        [type]="order.transportType"
        [ship]="order.ship"
        >

        </app-transport-type-icon>
      </div>

      <!-- Puerto destino -->
      <div class="flex justify-content-start" style="width: 25%;">
        <div class="flex justify-content-center align-items-center">
          <!-- <section class="country-section" *ngIf="order.transportType === 0">
            <figure *ngIf="order.destinationPort" class="figure-country">
              <img [flag]="order.destinationPort.country?.code"
                alt="" class="img-country"/>
            </figure>
            <div class="section-country-text text-size-base">
              <section>
                <span *ngIf="order.destinationPort?.name; else emptyDestination" class="font-semibold">
                  {{ order.destinationPort?.name }}
                </span>
                <ng-template #emptyDestination>
                  <span class="text-sub-color font-italic">{{ 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}</span>
                </ng-template>
                <br>
                {{ order.destinationPort ? (order.destinationPort.country | countryDescription) : '' }}
              </section>
            </div>
          </section>
          <section class="country-section" *ngIf="order.transportType === 1">
            <figure class="figure-country" *ngIf="order.destinationAirport">
              <img [flag]="order.destinationAirport.country?.code"
                alt="" class="img-country"/>
            </figure>
            <div class="section-country-text text-size-base">
              <section>
                {{ order.destinationAirport?.name ?? 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}
                <br>
                {{ order.destinationAirport ? (order.destinationAirport.country | countryDescription) : '' }}
              </section>
            </div>
          </section> -->
          <app-location-info
          [type]="order.transportType"
          [countryCode]="order.destinationPort?.country?.code ||
          order.destinationAirport?.country?.code || order.destinationCity?.country?.code"
          [countryName]="order.destinationPort?.country ?
            (order.destinationPort?.country | countryDescription) :
            (order.destinationAirport?.country ?
            (order.destinationAirport?.country | countryDescription) :
            (order.destinationCity?.country ?
            (order.destinationCity?.country | countryDescription) : ''))"
          [portName]="order.destinationPort?.name"
          [airportName]="order.destinationAirport?.name"
          [cityName]="order.destinationCity?.name"
          [showLocationName]="true"
          [useFigureIcon]="true"
          >
        </app-location-info>
        </div>
      </div>

      <!-- Importer -->
      <div class="flex justify-content-center" style="width: 25%;">
        <div class="flex flex-row align-items-center">
          <span class="material-symbols-outlined importer-icon hidden xl:flex">person</span>
          <div class="flex flex-column pl-2">
            <span class="text-size-base font-semibold">
              {{'UserPages.UserLoadOrdersProgram.SubTable.ImporterHeader' | translate}}:
            </span>
            <span class="text-size-base">
              {{ order.importerName }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex justify-content-end" style="width: 8%;">
        <p-button
          (onClick)="onToggleDetail(order)"
          [icon]="order.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          styleClass="p-button-rounded p-button-text p-button-sm"
          class="btn-toggle"
          [ngClass]="{
            'btn-expanded': order.expanded,
            'btn-collapsed': !order.expanded
          }">
        </p-button>
      </div>
    </div>
  </div>

  <div  *ngIf="order.expanded" class="container-expanded w-full">
    <div class="flex flex-row p-3">
      <div style="width: 48%" class="flex flex-row justify-content-between align-items-center border-right-1 border-300 pr-border">

        <div class="flex flex-column w-5 align-self-start">
          <span class="text-detail text-detail-color pb-2">{{'UserPages.UserLoadOrdersProgram.SubTable.ProductDetailHeader' | translate}}</span>

          <div class="flex flex-row text-size-base">
            <span class="pr-1">{{'UserPages.UserLoadOrdersProgram.SubTable.BoxHeader' | translate}}:</span>
            <span class="text-sub-color" [ngClass]="{'font-italic': !order.boxesQuantity?.toString()}">
              {{ order.boxesQuantity?.toString() ?? 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}
            </span>
          </div>
          <div *ngIf="!isProgram" class="flex flex-row text-size-base">
            <span class="pr-1">{{'UserPages.UserLoadOrdersProgram.SubTable.ETDHeader' | translate}}:</span>
            <span class="text-sub-color" *ngIf="order.etd; else emptyEtd">{{ (order.etd | date: 'dd-MM-yyyy') }}</span>
            <ng-template #emptyEtd>
              <span class="text-sub-color font-italic">{{ 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}</span>
            </ng-template>
          </div>
          <div class="flex flex-row text-size-base">
            <span class="pr-1">{{'UserPages.UserLoadOrdersProgram.SubTable.ETAHeader' | translate}}:</span>
            <span class="text-sub-color" *ngIf="order.eta; else emptyEta">{{ (order.eta | date: 'dd-MM-yyyy') }}</span>
            <ng-template #emptyEta>
              <span class="text-sub-color font-italic">{{ 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}</span>
            </ng-template>
          </div>
          <div class="flex flex-row text-size-base">
            <span class="pr-1">{{'UserPages.UserLoadOrdersProgram.SubTable.WeekYearHeader' | translate}}:</span>
            <span *ngIf="order.week; else emptyWeek" class="text-sub-color">
              {{ order.week }} - {{ year }}
            </span>
            <ng-template #emptyWeek>
              <span class="pl-2 text-sub-color text-size-base font-italic">
                {{ 'UserPages.UserLoadOrdersProgram.MainTable.PendingText' | translate }}
              </span>
            </ng-template>
          </div>
        </div>

        <div class="flex flex-column xl:flex-row xl:gap-2 w-7 align-items-center">
          <!-- Botón ver pallets -->
          <div class="flex w-12 xl:w-6 align-items-center">
            <p-button (onClick)="onClickOpenPallets(order)"
              styleClass="p-button" class="btn-action btn-detail w-full"
              label="{{'UserPages.UserLoadOrdersProgram.MainTable.SeePalletsBtn' | translate}}">
              <i class="pi pi-table text-lg mr-2"></i>
            </p-button>
          </div>

          <!-- Botón documentos -->
          <div class="flex w-12 xl:w-6 xl:justify-content-end mt-2 xl:mt-0">
            <p-button (onClick)="onClickOpenDocuments(order)"
              styleClass="p-button" class="btn-action btn-detail w-full"
              label="{{'UserPages.UserLoadOrdersProgram.MainTable.DocumentsBtn' | translate}}">
              <i class="material-symbols-outlined text-xl mr-2">file_copy</i>
            </p-button>
          </div>
        </div>
      </div>

      <div style="width: 52%" class="flex flex-row justify-content-between align-items-stretch flex-wrap pl-border">

        <div class="flex flex-column w-5">
          <span class="text-detail text-detail-color pb-2">{{'UserPages.UserLoadOrdersProgram.SubTable.AgreementHeader' | translate}}</span>

          <div *ngIf="profile?.type !== 1" class="flex flex-row flex-wrap align-items-center text-size-base">
            <span class="material-symbols-outlined text-main-color text-lg">person</span>
            <span class="pl-1 text-main-color font-medium">{{'UserPages.UserLoadOrdersProgram.SubTable.ExporterHeader' | translate}}:</span>
            <span class="pl-1 text-sub-color">{{ order.exporterCompanyName }}</span>
          </div>
          <div *ngIf="profile?.type === 1" class="flex flex-row flex-wrap align-items-center text-size-base">
            <span class="material-symbols-outlined text-main-color text-lg">person</span>
            <span class="pl-1 text-main-color font-medium">{{'UserPages.UserLoadOrdersProgram.SubTable.ConsigneeHeader' | translate}}:</span>
            <span class="pl-1 text-sub-color">{{ order.consignee }}</span>
          </div>
          <div *ngIf="profile?.type === 1" class="flex flex-row align-items-center text-size-base">
            <span class="material-symbols-outlined text-main-color text-lg">person</span>
            <span class="pl-1 text-main-color font-medium">{{'UserPages.UserLoadOrdersProgram.SubTable.NotifyHeader' | translate}}:</span>
            <span class="pl-1 text-sub-color">{{ order.notify }}</span>
          </div>
        </div>

        <div class="flex flex-column xl:flex-row xl:gap-2 w-7 align-items-center justify-content-center"
          style="width: 48%">
          <!-- Botón instructivo -->
          <div class="flex w-12 xl:w-6 align-items-center justify-content-end">
            <p-button (onClick)="onClickOpenInstructive(order)"
              styleClass="p-button" class="btn-action btn-detail w-full"
              label="{{'UserPages.UserLoadOrdersProgram.MainTable.InstructiveBtn' | translate}}">
              <i class="material-symbols-outlined text-xl mr-2">integration_instructions</i>
            </p-button>
          </div>

          <!-- Botón packing list -->
          <div class="flex w-12 xl:w-6 justify-content-end mt-2 xl:mt-0">
            <p-button (onClick)="onClickOpenPackingList(order)"
              styleClass="p-button" class="btn-action btn-detail w-full"
              label="{{'UserPages.UserLoadOrdersProgram.MainTable.PackingListBtn' | translate}}">
              <i class="material-symbols-outlined text-xl mr-2">format_list_bulleted</i>
            </p-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
